var _circle, _path, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 15.6,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.8 16 6.9-6.9c.7-.7.7-1.7 0-2.4S10 6 9.3 6.7l-8.1 8.1c-.2.3-.4.8-.4 1.2s.2.9.5 1.2l8.1 8.1c.3.3.8.5 1.2.5s.9-.2 1.2-.5.5-.7.5-1.2c0-.4-.2-.9-.5-1.2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8,
    cy: 15.6,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 15.6,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.8-8.1-8.1c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5-.5.7-.5 1.2c0 .4.2.9.5 1.2l6.9 6.9-6.9 6.9c-.7.7-.7 1.7 0 2.4.3.3.7.5 1.2.5.4 0 .9-.2 1.2-.5l8.1-8.1c.3-.3.5-.7.5-1.2 0-.4-.2-.9-.5-1.2"
  })));
};
export default SvgTransfer;